<template>
	<div v-if="commonService.isMobile()" class="p-grid p-fluid p-justify-center" style="margin-top: -40px;">
		<HomeHeader />
		<div class="p-col-12">
			<div>
				<Toast />
				<div class="p-grid">
					<div class="p-col-12">
						<label>{{$t('email')}}</label>
					</div>
					<div class="p-col-12">
						<InputText v-model="email" :class="{ 'p-error': loginClicked && !email }" />
					</div>
					<div class="p-col-12">
						<label>{{$t('password')}}</label>
					</div>
					<div class="p-col-12">
						<Password v-model="password" :feedback="false" :class="{ 'p-error': loginClicked && !password }" />
					</div>
					<div class="p-col-4 p-md-3" style="margin-top: 20px">
						<Button :label="$t('login')" @click="loginToTirolibre" />
					</div>
					<div class="p-col" style="margin-top: 20px">
						<div class="p-col">
							<router-link to="/register">{{$t('register')}}</router-link>
						</div>
					</div>
					<div class="p-col-4 p-md-3" style="margin-top: 20px">
						<LanguageSelector />
					</div>
					<div class="p-col-12">
						<router-link to="/recovery">{{$t('rememberPassword')}}</router-link>
					</div>
				</div>
			</div>
		</div>
		<HomeFoot />
	</div>
	<div v-else class="p-grid p-fluid p-justify-center" style="margin-top: -40px;">
		<HomeHeader />
		<div class="p-col-12 margin-top margin-left-right" style="width: 45%;">
			<div class="card card-w-title" style="margin: 40px; width: 70%; margin-left: auto; margin-right: auto;">
				<Toast />
				<div class="card card-w-title" style="margin: 40px; width: 85%;">
					<h1>{{$t('login')}}</h1>
					<div class="p-grid">
						<div class="p-col-12" style="margin-top: 10px">
							<label>{{$t('email')}}</label>
						</div>
						<div class="p-col-12">
							<InputText v-model="email" :class="{ 'p-error': loginClicked && !email }" />
						</div>
						<div class="p-col-12">
							<label>{{$t('password')}}</label>
						</div>
						<div class="p-col-12">
							<Password v-model="password" :feedback="false" :class="{ 'p-error': loginClicked && !password }" />
						</div>
						<div class="p-col-4 p-md-3" style="margin-top: 20px">
							<Button :label="$t('login')" @click="loginToTirolibre" />
						</div>
						<div class="p-col">
							<div class="p-col" style="margin-top: 20px">
								<router-link to="/register">{{$t('register')}}</router-link>
							</div>
						</div>
						<div class="p-col-4 p-md-3" style="margin-top: 20px">
							<LanguageSelector />
						</div>
						<div class="p-col-12">
							<router-link to="/recovery">{{$t('rememberPassword')}}</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<HomeFoot />
	</div>
</template>

<script>
import AuthService from "@/service/AuthService";
import CommonService from "@/service/CommonService";
import HomeFoot from "@/components/home/HomeFoot";
import HomeHeader from "@/components/home/HomeHeader";

export default {
	components: {
		HomeFoot,
		HomeHeader,
	},
	data() {
		return {
			email: "",
			password: "",
			loginClicked: false,
		};
	},
	beforeCreate: function () {
		document.body.className = "login";
	},
	authService: null,
	commonService: null,
	created() {
		this.authService = new AuthService();
		this.commonService = new CommonService();
	},
	methods: {
		loginToTirolibre() {
			let self = this;
			this.loginClicked = true;
			if (this.email && this.password) {
				this.authService.login(this.email, this.password).then(
					(res) => {
						self.$router.push("/");
						return res;
					},
					function (error) {
						self.$toast.add({
							severity: "error",
							summary: self.$t("errorMessage"),
							detail: self.$t(error),
							life: 3000,
						});
					}
				);
			}
		},
		login() {
			this.$router.push("/login");
		},
		register() {
			this.$router.push("/register");
		},
	},
};
</script>

<style scoped>
.login-box {
	background-color: #94b8ca;
	border-radius: 25px;
	width: 40%;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -80px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 22px;
}

.brand-text {
	font-size: 20px;
	font-weight: bold;
	margin: auto 30px;
}

@media (min-width: 1000px) and (max-width: 1600px) {
	.margin-top-left {
		margin-top: 45px !important;
	}

	.margin-top {
		margin-top: 45px !important;
	}

	.margin-left-right {
		margin-left: -50px !important;
	}

	.login-title {
		font-size: 50px;
	}

	.login-subtitle {
		font-size: 25px;
		margin-top: -60px;
	}

	.login-text {
		font-size: 20px;
	}
}

@media (min-width: 1000px) and (max-width: 1600px) {
	.brand-text {
		margin-top: 8px;
		font-size: 15px;
		font-weight: bold;
	}
}

.login-title-mobile {
	margin-top: -10px;
	font-size: 35px;
	font-weight: bold;
}

.login-subtitle-mobile {
	margin-top: -40px;
	font-size: 20px;
	font-weight: bold;
}

.login-text-mobile {
	margin-top: 10px;
	font-size: 15px;
}
</style>
